(function () {

    'use strict';

    angular.module('iplusjs.overlay.wait', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.html'
    ])
    .component('iplusjsWaitOverlay', {
        bindings: {
            url: '<iwoUrl',
            onClosePromise: '<iwoOnClosePromise',
            options: '<iwoOptions'
        },
        templateUrl: 'common/overlay/waitOverlay.html',
        controller: WaitOverlayController,
        controllerAs: 'waitOverlayVm'
    })
    .service('WaitOverlayService', WaitOverlayService);

    WaitOverlayController.$inject = [
        '$interval',
        '$q',
        'WaitOverlayService',
        'MiscUtilsService',
        'HtmlUtilsService'
    ];
    function WaitOverlayController($interval, $q, WaitOverlayService, MiscUtilsService, HtmlUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.$doCheck = doCheck;

        vm.focus = focus;
        vm.isCloseable = isCloseable;
        vm.close = close;

        function activate() {
            var overlay;

            vm.options = vm.options || {};
            vm.onClose = vm.onClosePromise || (function () {
                return $q(function (resolve, reject) {
                    resolve();
                });
            })();

            overlay = WaitOverlayService.get();

            if (vm.url) {
                if (!overlay.popup) {
                    WaitOverlayService.open(vm.url, getOverlayOptions());
                } else {
                    WaitOverlayService.setOptions(vm.url, getOverlayOptions());
                    WaitOverlayService.redirect(vm.url);
                }
            } else {
                WaitOverlayService.close();
            }

            vm.isVisible = WaitOverlayService.isVisible();
        }
        function getOverlayOptions(options) {
            var visible = MiscUtilsService.isEmpty(vm.options.visible) ? true : vm.options.visible;

            return {
                name: vm.options.popupName,
                visible: visible,
                width: vm.options.popupWidth,
                height: vm.options.popupHeight,
                popupOptions: vm.options.popupOptions,
                onClosePromise: vm.onClosePromise
            };
        }
        function onInit() {
            activate();
        }

        function onChanges(changes) {
            if (changes.url && !changes.url.isFirstChange()) {
                WaitOverlayService.setUrl(vm.url);
            }

            if (changes.onClosePromise && !changes.onClosePromise.isFirstChange()) {
                WaitOverlayService.setOnClosePromise(vm.onClosePromise);
                WaitOverlayService.initCloseInterval();
            }

            activate();
        }

        function doCheck() {
            vm.isVisible = WaitOverlayService.isVisible();
        }
        function focus() {
            var overlay = WaitOverlayService.get();

            if (overlay && (!overlay.popup || HtmlUtilsService.isWindowClosed(overlay.popup)) && overlay.url) {
                WaitOverlayService.open(overlay.url, overlay);
            } else {
                WaitOverlayService.focus();
            }
        }
        function isCloseable() {
            return !!vm.onClosePromise;
        }
        function close() {
            WaitOverlayService.close();
            vm.isVisible = WaitOverlayService.isVisible();

            vm.onClose().then(function () {
            }).catch(function (error) {
            });
        }
    }

    WaitOverlayService.$inject = [
        '$rootScope',
        '$window',
        '$interval',
        'lodash',
        'AppConfig',
        'HtmlUtilsService'
    ];

    function WaitOverlayService($rootScope, $window, $interval, _, AppConfig, HtmlUtilsService) {
        var that = this,
            overlay = {};

        that.setUrl = setUrl;
        that.setOnClosePromise = setOnClosePromise;
        that.resetOnClosePromise = resetOnClosePromise;
        that.setOptions = setOptions;
        that.open = open;
        that.show = show;
        that.hide = hide;
        that.focus = focus;
        that.isVisible = isVisible;
        that.get = get;
        that.close = close;
        that.redirect = redirect;
        that.initCloseInterval = initCloseInterval;
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toStateParams, fromState, fromStateParams) {
            if (isVisible()) {
                event.preventDefault();
                return;
            }
        });
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if (isVisible()) {
                event.preventDefault();
                return;
            }
        });
        function setUrl(url) {
            if (!overlay) {
                return;
            }

            overlay.url = url;
        }
        function setOnClosePromise(onClosePromise) {
            if (!overlay) {
                return;
            }

            overlay.onClosePromise = onClosePromise;
        }
        function resetOnClosePromise() {
            if (!overlay) {
                return;
            }

            overlay.onClosePromise = null;
        }
        function setOptions(url, options) {
            overlay.url = url;

            if (options) {
                overlay.onClosePromise = options.onClosePromise;
                overlay.width = options.width;
                overlay.height = options.height;
                overlay.name = options.name;
                overlay.visible = options.visible;
            }
        }
        function open(url, options) {
            options = options || {};

            setOptions(url, options);

            overlay.popup = HtmlUtilsService.openPopup(url, {
                name: overlay.name,
                popupOptions: options.popupOptions || 'scrollbars=yes,resizable=yes,menubar=yes,status=yes',
                width: overlay.width,
                height: overlay.height
            });

            initCloseInterval();

            if (overlay.visible) {
                show();
            } else {
                hide();
            }

            return overlay;
        }
        function show() {
            if (!overlay) {
                return;
            }

            overlay.visible = true;
        }
        function hide() {
            if (!overlay) {
                return;
            }

            overlay.visible = false;
        }
        function focus() {
            if (!overlay) {
                return;
            }

            if (overlay.popup) {
                overlay.popup.focus();
            }
        }
        function isVisible() {
            return _.get(overlay, 'visible') === true;
        }
        function get() {
            return overlay || {};
        }
        function close(closePopup) {
            if (!overlay) {
                return;
            }

            if (overlay.popup && closePopup !== false) {
                overlay.popup.close();
            }

            if (overlay.timer) {
                $interval.cancel(overlay.timer);
            }

            hide();
            overlay = {};
        }
        function redirect(url) {
            if (!overlay) {
                return;
            }

            try {
                if (!HtmlUtilsService.isWindowClosed(overlay.popup)) {
                    overlay.popup.location.href = url;
                }

                show();
                focus();
            } catch (error) {
            }
        }
        function initCloseInterval() {
            if (!overlay) {
                return;
            }

            if (overlay.popup && overlay.timer) {
                $interval.cancel(overlay.timer);
            }

            if (overlay.popup && !HtmlUtilsService.isWindowClosed(overlay.popup) && overlay.onClosePromise && !overlay.timer) {
                overlay.timer = $interval(function () {
                    if (HtmlUtilsService.isWindowClosed(overlay.popup)) {
                        $interval.cancel(overlay.timer);

                        overlay.onClosePromise().then(function () {
                        }).catch(function (error) {
                        });

                        close();
                    }
                }, 250);
            }
        }
    }
})();
